// Utility to compute the next occurrence of a recurring weekly show
// defined in America/Chicago timezone, returned as a JS Date in UTC.

const TZ = "America/Chicago";

function getTzDateParts(date, timeZone = TZ) {
  const fmt = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    weekday: "short",
  });
  const parts = fmt.formatToParts(date).reduce((acc, p) => {
    acc[p.type] = p.value;
    return acc;
  }, {});
  const weekdayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  return {
    year: parseInt(parts.year, 10),
    month: parseInt(parts.month, 10),
    day: parseInt(parts.day, 10),
    hour: parseInt(parts.hour === "24" ? "0" : parts.hour, 10),
    minute: parseInt(parts.minute, 10),
    weekday: weekdayMap[parts.weekday],
  };
}

// Convert (year, month, day, hour, minute) interpreted as TZ wall-clock into a UTC Date.
function tzDateToUtc(year, month, day, hour, minute, timeZone = TZ) {
  const naive = new Date(Date.UTC(year, month - 1, day, hour, minute, 0));
  const parts = getTzDateParts(naive, timeZone);
  const chicagoAsUTC = Date.UTC(
    parts.year,
    parts.month - 1,
    parts.day,
    parts.hour,
    parts.minute,
    0
  );
  const offset = naive.getTime() - chicagoAsUTC;
  return new Date(naive.getTime() + offset);
}

// Get the next occurrence of (targetWeekday at hour:minute Chicago time) from `from`.
function nextOccurrence(targetWeekday, hour, minute, from = new Date()) {
  const todayCh = getTzDateParts(from);
  // Compute today's same wall-clock target in UTC
  const todayTargetUtc = tzDateToUtc(
    todayCh.year,
    todayCh.month,
    todayCh.day,
    hour,
    minute
  );

  let daysToAdd = (targetWeekday - todayCh.weekday + 7) % 7;
  if (daysToAdd === 0 && todayTargetUtc.getTime() <= from.getTime()) {
    daysToAdd = 7;
  }

  // Compute target Chicago date
  const targetYmd = new Date(
    Date.UTC(todayCh.year, todayCh.month - 1, todayCh.day + daysToAdd)
  );
  return tzDateToUtc(
    targetYmd.getUTCFullYear(),
    targetYmd.getUTCMonth() + 1,
    targetYmd.getUTCDate(),
    hour,
    minute
  );
}

export const SHOWS = [
  { id: "monday", label: "Inspiration for Life", weekday: 1, hour: 19, minute: 0, ctTime: "7 PM CST" },
  { id: "friday", label: "Friday Night Highlights", weekday: 5, hour: 21, minute: 0, ctTime: "9 PM CST" },
];

export function getNextShow(from = new Date()) {
  let best = null;
  for (const show of SHOWS) {
    const when = nextOccurrence(show.weekday, show.hour, show.minute, from);
    if (!best || when.getTime() < best.when.getTime()) {
      best = { ...show, when };
    }
  }
  return best;
}

export function formatCountdown(target, from = new Date()) {
  const ms = target.getTime() - from.getTime();
  if (ms <= 0) return "now";
  const totalMin = Math.floor(ms / 60000);
  const days = Math.floor(totalMin / (60 * 24));
  const hours = Math.floor((totalMin % (60 * 24)) / 60);
  const mins = totalMin % 60;
  if (days >= 1) return `${days}d ${hours}h`;
  if (hours >= 1) return `${hours}h ${mins}m`;
  return `${mins}m`;
}

export function formatLocalTime(date) {
  const fmt = new Intl.DateTimeFormat(undefined, {
    weekday: "short",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
  });
  return fmt.format(date);
}
